<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <el-card class="rightContent">
              <h3>
                测试案例
                <span style="float: right">
                  <el-button
                    type="primary"
                    @click="createClassDialogVisible = true"
                  >
                    + 创建案例</el-button
                  >
                </span>
              </h3>
              <el-divider></el-divider>
              <el-input
                v-model="caseKeyword"
                size="medium"
                placeholder="请输入检索关键词"
                style="width: 300px"
              >
                <template v-slot:append>
                  <el-button
                    icon="el-icon-search"
                    @click="searchClass"
                  ></el-button>
                </template>
              </el-input>
              <el-table
                ref="filterTable"
                :data="caseList"
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column prop="name" label="名称" min-width="30%">
                </el-table-column>
                <el-table-column prop="type" label="类型" min-width="20%">
                </el-table-column>
                <el-table-column prop="creator" label="创建者" min-width="10%">
                </el-table-column>
                <el-table-column prop="difficulty" label="难度" min-width="20%">
                </el-table-column>
                <el-table-column
                  v-if="isManager"
                  prop="delete"
                  label="操作"
                  min-width="20%"
                >
                  <template v-slot="scope">
                    <el-button
                      v-if="!scope.row.selected"
                      @click="addToCaseSelectedList(scope.row)"
                      type="primary"
                      size="small"
                      >+添加
                    </el-button>
                    <el-button v-else size="small">已添加</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalPage"
                style="float: right; margin: 20px"
                v-model:current-page="currentPage"
              >
              </el-pagination>
            </el-card>
            <el-card class="caseSelectedArea">
              <template v-slot:header>
                <div class="clearfix">
                  <span>试题夹</span>
                  <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    @click="goCreatePaperWithCaseList"
                    >出卷
                  </el-button>
                </div>
              </template>
              <div
                v-for="caseItem in selectedCaseList"
                :key="caseItem.id"
                class="selectedCaseItem"
              >
                <div class="name">{{ caseItem.name }}</div>
                <div class="delete" @click="deleteSelectedCase(caseItem)">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </el-card>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 优化点
import { caseListGet } from "@/api/paper";
import Leftbar from "@/components/newComponent/Leftbar";

export default {
  components: {
    Leftbar,
  },
  name: "class",
  bodyClass: "index-page",
  data() {
    return {
      caseList: [
        // {
        //   id: 3954,
        //   name: "钱钱1",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3952,
        //   name: "钱钱2",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3950,
        //   name: "钱钱3",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3945,
        //   name: "钱钱4",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3943,
        //   name: "钱钱5",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3942,
        //   name: "钱钱6",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3699,
        //   name: "钱钱63",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3629,
        //   name: "钱钱62",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3602,
        //   name: "钱钱633",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
        // {
        //   id: 3601,
        //   name: "钱钱6222",
        //   type: "移动应用测试",
        //   creator: "mooctest",
        //   difficulty: 2,
        // },
      ],
      createClassDialogVisible: false,
      caseKeyword: "",
      totalPage: 1,
      isManager: true,
      currentPage: 1,
      loading: false,
      selectedCaseList: [],
      selectedCaseIdList: [],
    };
  },
  beforeMount() {},
  mounted() {
    this.selectedCaseList = this.$route.params.selectedCaseList || [];
    this.selectedCaseList.forEach((cur) => {
      this.selectedCaseIdList.push(cur.id);
    });
    this.initCaseListList(this.caseKeyword, this.currentPage);
  },
  methods: {
    initCaseListList(keyword, currentPage) {
      caseListGet(keyword, currentPage).then((res) => {
        this.caseList = this.formatCaseList(res.content);
      });
      this.formatCaseList();
    },
    searchClass() {
      this.initcaseList(this.caseKeyword, this.currentPage);
    },
    addToCaseSelectedList(row) {
      this.selectedCaseList.push(row);
      this.selectedCaseIdList.push(row.id);
      this.formatCaseList(this.caseList);
    },
    formatCaseList(list) {
      list.map((cur, index) => {
        if (this.selectedCaseIdList.includes(cur.id)) {
          this.$set(this.caseList, index, { ...cur, selected: true });
        }
      });
      return list;
    },
    deleteSelectedCase(caseItem) {
      this.caseList.map((cur, index) => {
        if (cur.id == caseItem.id) {
          this.$set(this.caseList, index, { ...cur, selected: false });
        }
      });
      this.selectedCaseList.map((cur, index) => {
        if (cur.id == caseItem.id) {
          this.selectedCaseList.splice(index, 1);
          this.selectedCaseIdList.splice(index, 1);
        }
      });
    },
    goCreatePaperWithCaseList() {
      this.$router.push({
        name: "paperCreate",
        params: {
          selectedCaseList: this.selectedCaseList,
        },
      });
    },
  },
  computed: {},
  watch: {
    currentPage(newVal, old) {
      this.searchClass();
    },
  },
  beforeUnmount() {},
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}

.caseSelectedArea {
  width: 20%;
  height: 100%;
}

.selectedCaseItem {
  width: 100%;
  //   border: 1px solid black;
  min-height: 50px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caseSelectedArea ::v-deep .el-card__body {
  padding: 0;
}
</style>
